exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1 {\n  text-align: center;\n  margin-bottom: 0px; }\n\n.calender-menu {\n  text-align: center;\n  margin-bottom: 1rem; }\n\n.calender-menu .date {\n    font-weight: bold; }\n\nul {\n  padding: 0;\n  list-style: none; }\n\nul li {\n    margin-top: 0.5em;\n    border-bottom: 1px solid #ad0e68; }\n\nul li .date {\n      margin-bottom: 0.5em;\n      font-weight: bold; }\n\nul li .title {\n      color: #ad0e68;\n      font-weight: bold; }\n\nul li .description {\n      overflow: hidden;\n      margin: 0.25em 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/calender/calender.component.scss
// module id = ../../../../../src/app/calender/calender.component.scss
// module chunks = main